import { render, staticRenderFns } from "./ParkingOccupancyDataTable.vue?vue&type=template&id=1126a250&scoped=true&"
import script from "./ParkingOccupancyDataTable.vue?vue&type=script&lang=js&"
export * from "./ParkingOccupancyDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ParkingOccupancyDataTable.vue?vue&type=style&index=0&id=1126a250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126a250",
  null
  
)

export default component.exports